import { basicGet,basicPost,basicPut,basicDelete } from "../../configurations/Axios/GenericMethods";
import { useAuth } from "../AuthContext/AuthContext";
import { CallbackFunction } from "../../configurations/Axios/GenericMethods";
import { visitaxClient } from "../../configurations/Axios/Clients";


/**
 * Hook exposing HTTP helper methods bound to the Visitax API.
 * Each request automatically includes the authentication token.
 */
const useAxios = () => {
    const {user}= useAuth();
    const VisitaxPost = (url: string, data: any, callback: CallbackFunction)=>{
        basicPost(visitaxClient,url,data,callback,user?.token||"");
    }
    const VisitaxGet = ( url: string, callback: CallbackFunction)=>{
       basicGet(visitaxClient,url,callback,user?.token||"");
    }
    const VisitaxPut = ( url: string, data: any, callback: CallbackFunction)=>{
        basicPut(visitaxClient,url,data,callback,user?.token||"");
    }
    const VisitaxDelet = (url: string, callback: CallbackFunction)=>{
        basicDelete(visitaxClient,url,callback,user?.token||"");
    }
    return {
        VisitaxPost,
        VisitaxGet,
        VisitaxPut,
        VisitaxDelet,
    }
}
export default useAxios;